// reducers.js
import {
    CLEAR_PRODUCT_MODAL_DATA_LIST,
    FETCH_BANNER,
    FETCH_DRAWER_MENU,
    FETCH_LATEST_VERSION,
    FETCH_PRODUCT_LIST, FETCH_PRODUCT_MODAL_DATA_LIST,
    SET_BANNER,
    SET_DRAWER_MENU, SET_LOADING, SET_PRODUCT_MODAL_DATA_LIST
} from '../actions';
import { SET_LATEST_VERSION } from "../actions";
// import {SET_LATEST_VERSION} from "./actionTypes";

const initialState = {
    productModalData: null,
    isLoading: false,
    error: null,
};

const productModalDataReducer = (state = initialState, action) => {


    switch (action.type) {

        // case MODAL_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.payload,
        //     };
        //
        // case SET_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload,
        //     };

        case FETCH_PRODUCT_MODAL_DATA_LIST:
            return {
                ...state,
            };

        case SET_PRODUCT_MODAL_DATA_LIST:
            return {
                ...state,
                productModalData: action.payload,
                isLoading: false,
            };
        case CLEAR_PRODUCT_MODAL_DATA_LIST:
            return {
                ...state,
                productModalData: null,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default productModalDataReducer;
